<template lang="pug">
  d2-container
    el-form(:model="searchForm" :inline="true" size="mini" label-suffix=":")
      div.search-box
        el-form-item(label="姓名")
          el-input.inputWidth(v-model="searchForm.name" placeholder="请输入姓名" clearable)
        el-form-item(label="性别")
          el-select.inputWidth(v-model="searchForm.gender" placeholder="请选择性别" clearable)
            el-option(label="男" value="0")
            el-option(label="女" value="1")
        el-form-item(label="会员账号")
          el-input.inputWidth(v-model="searchForm.mobile" placeholder="请输入会员账号" clearable)
        el-form-item(label="当前级别")
          el-select.inputWidth(v-model="searchForm.beforeLevel" placeholder="请选择当前级别" clearable)
            el-option(label="2.0" value="2.0")
            el-option(label="2.5" value="2.5")
            el-option(label="3.0" value="3.0")
            el-option(label="3.5" value="3.5")
            el-option(label="4.0" value="4.0")
            el-option(label="4.5" value="4.5")
            el-option(label="5.0" value="5.0")
        el-form-item(label="比赛时间")
          el-date-picker(
            style="width: 300px;"
            v-model="timeRange"
            range-separator="至"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          )
      div.search-btn
        el-button(type="primary" @click="exportExcel") 导出列表
        el-button(type="primary" icon="el-icon-search" @click="getDataList") 查 询
    el-table(:data="tableData" v-loading="dataListLoading" border)
      el-table-column(prop="name" header-align="center" align="center" label="姓名")
      el-table-column(prop="gender" header-align="center" align="center" label="性别")
        template(slot-scope="scope")
          font(v-if="scope.row.gender === 0") 男
          font(v-if="scope.row.gender === 1") 女
      el-table-column(prop="mobile" header-align="center" align="center" label="会员账号")
      el-table-column(prop="beforeLevel" header-align="center" align="center" label="当前级别")
      el-table-column(prop="matchCount" header-align="center" align="center" label="有效比赛站数" )
      el-table-column(prop="validScore" header-align="center" align="center" label="有效比赛平均积分")
      el-table-column(prop="winRate" header-align="center" align="center" label="升级时胜率(%)")
      el-table-column(prop="createTime" header-align="center" align="center" label="升级条件满足时间")
      el-table-column(header-align="center" align="center" label="操作" width="100")
        template(slot-scope="scope")
          el-menu.menuPonit(:collapse="isCollapse")
            el-submenu(index="1")
              template(slot="title")
                i(class="el-icon-more" style="color: #02B90D;")
              el-menu-item-group()
                el-menu-item(index="1-1" @click="updatePromotion(scope.row.id)") 升级通过
                el-menu-item(index="1-2" @click="viewHandle(scope.row.mbId)") 查看基本信息
                el-menu-item(index="1-3" @click="gameListHandle(scope.row.mbId)") 查看比赛记录
    el-pagination(
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    )
    view-info(v-if="viewVisible" ref="viewInfo" @refreshDataList="getDataList")
</template>

<script>
import table from './table.js'
import ViewInfo from '../member/view-info.vue'

export default {
  name: 'reserveSite-site',
  components: {
    ViewInfo
  },
  data () {
    return {
      timeRange: null,
      searchForm: {
        page: 1,
        rows: 10,
        name: '', // 姓名
        gender: '', // 性别
        mobile: '', // 会员账号
        beforeLevel: '', // 当前级别
        startTime: '', // 开始时间
        endTime: '' // 结束时间
      },
      dataListLoading: false, // 表格加载中
      isCollapse: true, // 表格菜单展开
      tableData: [], // 列表数据
      totalPage: 0, // 总页数
      viewVisible: false, // 查看基本信息
      // 导出报表
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      }
    }
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    // 列表分页查询
    getDataList () {
      this.dataListLoading = true
      if (this.timeRange && this.timeRange.length > 0) {
        this.searchForm.startTime = this.timeRange[0]
        this.searchForm.endTime = this.timeRange[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
      this.$http({
        url: this.$http.adornUrl('/mbMember/queryMbPromotionPage'),
        method: 'post',
        data: this.searchForm
      })
        .then(data => {
          if (data && data.code === 0) {
            this.tableData = data.page.records
            this.totalPage = data.page.total
          } else {
            this.tableData = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.searchForm.rows = val
      this.searchForm.page = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.searchForm.page = val
      this.getDataList()
    },
    // 按照条件查询
    queryList () {
      this.searchForm.page = 1
      this.getDataList()
    },
    // 查看基本信息
    viewHandle (id) {
      this.viewVisible = true
      this.$nextTick(() => {
        this.$refs.viewInfo.init1(id)
      })
    },
    // 查看比赛记录
    gameListHandle (id) {
      this.$router.push({
        path: './game',
        query: { mbId: id }
      })
    },
    // 升级通过
    updatePromotion (id) {
      this.$confirm(`是否确认升级该会员？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
      .then(() => {
          const data = {
            id,
            status: 20
          }
          this.$http({
              url: this.$http.adornUrl('/mbMember/updateMbPromotionStatus'),
              method: 'post',
              data
          })
          .then(data => {
              if (data && data.code === 0) {
                  this.$message.success('升级成功')
                  this.getDataList()
              } else {
                  this.$message.error(data.msg || '升级失败，请稍后再试')
              }
          })
      })
    },
    //导出报表
    exportExcel () {
      if (this.timeRange && this.timeRange.length > 0) {
        this.searchForm.startTime = this.timeRange[0]
        this.searchForm.endTime = this.timeRange[1]
      } else {
        this.searchForm.startTime = ''
        this.searchForm.endTime = ''
      }
      this.$http({
        url: this.$http.adornUrl('/mbMember/queryMbPromotionPage'),
        method: 'post',
        data: {
          ...this.searchForm,
          rows: 100000
        }
      })
        .then(data => {
          if (data && data.code === 0) {
            // 为空判断
            if (data.page.records == null || data.page.records.length === 0) {
              return this.$message.info('没有要导出的数据！')
            }
            // 数据转化
            let exportData = data.page.records
            for (let i of exportData) {
              i.__gender__ = {
                0: '男',
                1: '女'
              }[i.gender]
            }
            // 导出表格
            this.$export.excel({
              columns: this.table.columns,
              data: exportData,
              title: '升级名单报表'
            }).then(() => {
              this.$message.success('升级名单报表导出成功')
            })
          }
        })
    }
  }
}
</script>

<style scoped>
/* 操作三点 菜单样式 */
@import '../../css/opr3dot.css';

.search-box {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.search-btn {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
</style>
